import type { BoundaryGroup } from '~/boundary/boundary.types';
import { blankBoundaryStyle } from '~/boundary/settings/defaultBoundarySettings';
import { type BoundaryTerritoryGroup } from '../../../../store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';

export const getBoundaryItemStyle = (boundaryTerritoryGroup: BoundaryTerritoryGroup | undefined, boundaryId?: number) => {
  if (boundaryId === undefined) {
    return blankBoundaryStyle;
  }

  return boundaryTerritoryGroup?.settings.boundaryStyle.get(boundaryId) ?? blankBoundaryStyle;
};

export const isBTGAiGenerated = (boundary: BoundaryTerritoryGroup, boundaryGroups: readonly BoundaryGroup[]) => {
  const matchingBoundaryGroup = boundaryGroups.find(boundaryGroup => boundaryGroup.id === boundary.boundaryGroupId);
  return !!matchingBoundaryGroup?.wms?.territoriesCount;
};
